import { DialogStep, DialogStepGesture } from '../../validation/schema/v1/story';
import { DialogLike } from '../types';

/**
 * This migration got introduced because we have switched to using animation key rather than full url.
 * And some old data contain full url causing issues.
 */

export const migrateGestureAnimation = async (dialog: DialogLike): Promise<DialogLike> => {
  console.info('migrateGestureAnimation')
  const steps = dialog.steps.map((step: DialogStep) => {
    const gestures = step.gestures.map((gesture: DialogStepGesture) => {
      const isUrl = gesture.gesture?.startsWith('https');
      if (isUrl) {
        return {
          ...gesture,
          gesture: gesture.gesture!.split('/').pop()?.split('?').shift(),
        }
      }
      return gesture;
    });
    return {
      ...step,
      gestures,
    }
  });

  return {
    ...dialog,
    steps
  }
};
